import { keyframes } from '@emotion/react';

export const float1 = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  25% { transform: translate(30px, -50px) scale(1.15); }
  50% { transform: translate(-20px, -100px) scale(0.9); }
  75% { transform: translate(25px, -70px) scale(1.1); }
`;

export const float2 = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(-40px, -70px) scale(1.2); }
  66% { transform: translate(35px, -120px) scale(0.85); }
`;

export const float3 = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(50px, -80px) scale(1.25); }
`;

export const float4 = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }
  20% { transform: translate(-25px, -40px) scale(1.1) rotate(5deg); }
  40% { transform: translate(40px, -90px) scale(0.9) rotate(-3deg); }
  60% { transform: translate(-10px, -130px) scale(1.15) rotate(8deg); }
  80% { transform: translate(20px, -70px) scale(0.95) rotate(-5deg); }
`;

export const float5 = keyframes`
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-150px) scale(1.2); }
`;

export const drift = keyframes`
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(80px, -30px); }
  50% { transform: translate(50px, 50px); }
  75% { transform: translate(-30px, 20px); }
`;

export const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.3; }
  50% { transform: scale(1.5); opacity: 0.15; }
`;

export const breathe = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.35; }
  50% { transform: scale(1.3); opacity: 0.2; }
`;

export const floatAnimations = [float1, float2, float3, float4, float5];
export const orbAnimations = [pulse, breathe, drift];
